import { Button, Container, Group, Title } from '@mantine/core';
import { IconExclamationCircleFilled } from '@tabler/icons-react';

import classes from './PageError.module.css';

export function PageError() {
  return (
    <div className={classes.root}>
      <Container>
        <div className={classes.label}>
          <IconExclamationCircleFilled size={60} />
        </div>
        <Title className={classes.title}>A apărut o eroare.</Title>
        <Group justify="center">
          <Button
            variant="outline"
            size="md"
            onClick={() => {
              location.href = '.';
            }}
          >
            Reîncearcă
          </Button>
        </Group>
      </Container>
    </div>
  );
}
